<div class="container">

  <div class="portalCard">

    <div class="aTitle">
      <mat-icon>leaderboard</mat-icon>
      <span>Mein Profil</span>
    </div>

    <div class="profilePanel">

      <div style="display: flex; flex-flow: column nowrap; gap: 20px;">

        <div class="colPicName">
          <div class="profileImageWrapper"
			[style.width.px]="avatarPx"
            [style.height.px]="avatarPx"
			>			
			<!-- Preferiere das vom Backend geladene Bild (full) als Preview -->
			<img
				*ngIf="profileImageUrl as src"
				[src]="src"
				[alt]="user.ebeName || 'Profilbild'"
				class="profileImage"
			/>
            <!-- Fallback: Web Component zeigt Mini-Avatar basierend auf ebeId -->
            <ng-container *ngIf="!profileImageUrl">              
              <app-avatar-circle
                [ebeId]="user.ebeId"
                [sizePx]="innerAvatarPx"
                [alt]="user.ebeName || 'Profilbild'"
                [attr.data-cache-buster]="avatarCacheBuster"
              ></app-avatar-circle>
            </ng-container>

			<div class="profileImageSpinner" *ngIf="isImageLoading || isUploading">
				<mat-spinner 
				[diameter]="spinnerDiameter"
                [style.--mdc-circular-progress-size.px]="spinnerDiameter"
				></mat-spinner>
			</div>

            <button
              mat-mini-fab
              color="primary"
              type="button"
              class="profileImageEditButton"
              aria-label="Profilbild bearbeiten"
              [matMenuTriggerFor]="profileImageMenu"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>

          <mat-menu #profileImageMenu="matMenu">
            <button mat-menu-item type="button" (click)="openFilePicker(fileInput)">
              <mat-icon>photo_library</mat-icon>
              <span>Bild auswählen</span>
            </button>
            <button mat-menu-item type="button" (click)="openFilePicker(cameraInput)">
              <mat-icon>photo_camera</mat-icon>
              <span>Foto aufnehmen</span>
            </button>
            <button mat-menu-item type="button" *ngIf="hasCustomImage" (click)="removeProfileImage()">
              <mat-icon>delete</mat-icon>
              <span>Bild entfernen</span>
            </button>
          </mat-menu>

          <input #fileInput type="file" accept=".jpe,.jpeg,.jpg,.gif,.png" hidden (change)="onProfileImageSelected($event)">
          <input #cameraInput type="file" accept=".jpe,.jpeg,.jpg,.gif,.png,image/*" capture="user" hidden (change)="onProfileImageSelected($event)">

          <div class="title">
            {{user.ebeVorname}} {{user.ebeName}}
          </div>
        </div>

        <div>
          <span class="aSubTitle">Benutzername:</span>
          <div>{{ user.ebeId }}</div>
        </div>

        <div>
          <span class="aSubTitle">Rolle:</span>
          @for (group of user.gruppen; track group) {
            <div>{{ txtRole[group] || group }}</div>
          }
        </div>

      </div>

      <div class="maxWidth">
        <div class="tabPanel">
          <mat-tab-group>

            <mat-tab label="Anschrift ändern">
              <app-change-address />
            </mat-tab>

            <mat-tab label="Passwort ändern">
              <div style="margin: 40px 0;">
                <app-change-password />
              </div>
            </mat-tab>

            <mat-tab label="Zwei-Faktor-Authentifizierung">
              <div style="margin: 5em 0;">
                <app-manage-2fa [user]="user" />
              </div>
            </mat-tab>

            <mat-tab label="News Rubriken">
              <div style="text-align: center;">
                <rubric-selector style="display: inline-block; margin: 2em 0; text-align: left;" />
              </div>
            </mat-tab>

            <mat-tab label="Veranstaltungsgruppen">
              <div style="text-align: center;">
                <calendar-group-selector style="display: inline-block; margin: 2em 0; text-align: left;" />
              </div>
            </mat-tab>

            @if (environment.features.austausch) {
              <mat-tab *ngIf="user.gruppen && !user.gruppen.includes('ADMIN')" label="Austauschkategorien">
                <div style="text-align: center;">
                  <documentexchange-category-selector style="display: inline-block; margin: 2em 0; text-align: left;" />
                </div>
              </mat-tab>
            }

            <mat-tab label="Angemeldete Veranstaltungen">
              <div style="text-align: center;">
                <app-subscribed-event-list style="display: inline-block; margin: 2em 0; text-align: left;">
                </app-subscribed-event-list>
              </div>
            </mat-tab>

            <mat-tab label="Abgemeldete Veranstaltungen">
              <div style="text-align: center;">
                <app-unsubscribed-event-list style="display: inline-block; margin: 2em 0; text-align: left;">
                </app-unsubscribed-event-list>
              </div>
            </mat-tab>

            <mat-tab label="Gut Beraten">
              <div style="text-align: center;">
                <app-gut-beraten style="display: inline-block; margin: 2em 0; text-align: left;">
                </app-gut-beraten>
              </div>
            </mat-tab>

          </mat-tab-group>
        </div>
      </div>

    </div>

  </div>

</div>



